import mutations from './attachmentsMutations'
import actions from './attachmentsActions'
import state from './attachmentsState'
import getters from './attachmentsGetters'

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}
